<div class="row no-gutters full-width">
  <div class="col-sm-5">
    <mat-form-field class="full-width">
      <mat-label>{{ vehicle.trans.kba_manufacturer | translate }}</mat-label>
      <input id="{{idPrefix}}{{vehicle.trans.kba_manufacturer}}"
             type="text"
             matInput
             maxlength="4"
             [(ngModel)]="vehicle.kba_manufacturer"
             [disabled]="disabled"
             (blur)="onChange('vehicle.kba_manufacturer', vehicle.kba_manufacturer)"
             uppercase>
    </mat-form-field>
  </div>
  <div class="col-sm-2 kba-separator-container" align="center">
    <span>/</span>
  </div>
  <div class="col-sm-5">
    <mat-form-field class="full-width">
      <mat-label>{{ vehicle.trans.kba_type | translate }}</mat-label>
      <input id="{{idPrefix}}{{vehicle.trans.kba_type}}"
             type="text"
             matInput
             maxlength="3"
             [(ngModel)]="vehicle.kba_type"
             [disabled]="disabled"
             (blur)="onChange('vehicle.kba_type', vehicle.kba_type)"
             uppercase>
    </mat-form-field>
  </div>
</div>
